import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const About = ({ setState }) => (
	<div className="about">
		<div class="exitbtn" onClick={() => setState('home')}>
			<FontAwesomeIcon icon={faArrowLeft} className="exitbtn__icon" />
		</div>
		about
	</div>
)

export default About;
